import { render, staticRenderFns } from "./new-purpose.vue?vue&type=template&id=ec0df06e"
import script from "./new-purpose.vue?vue&type=script&lang=js"
export * from "./new-purpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec0df06e')) {
      api.createRecord('ec0df06e', component.options)
    } else {
      api.reload('ec0df06e', component.options)
    }
    module.hot.accept("./new-purpose.vue?vue&type=template&id=ec0df06e", function () {
      api.rerender('ec0df06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rule-engine/data-purpose/new-purpose.vue"
export default component.exports